import { format } from 'date-fns';
import React, { memo, useEffect, useRef, useState } from 'react'
import { Offcanvas } from 'react-bootstrap';
import { PrivateAxios, PrivateAxiosFile, url } from '../environment/AxiosInstance';
import { UserAuth } from '../pages/auth/Auth';
import { isURL, splitText } from '../environment/Helper';
import moment, { suppressDeprecationWarnings } from 'moment';
import { SuccessMessage, WaringMessage } from '../environment/ToastMessage';
import { Tooltip } from 'antd';

function ProjectMessage({ show, handleClose, title, GetTodoByTask, GetcompleteByTask, GetcloseByTask, GetinprogressByTask, Tab, data }) {
    const { userDetails } = UserAuth();
    const { Logout, User } = UserAuth();
    const [fileCount, setFileCount] = useState(0);
    const [msg, setMsg] = useState([]);
    const [msgData, setMsgData] = useState({
        project_id: "",
        user_id: "",
        message: "",
        file: ""
    })


    const GetMessage = async () => {
        PrivateAxios.get(`project/get-project-messages/${data.id}`)
            .then((res) => {
                setMsg(res.data.data);
            }).catch((err) => {
                if (err.response?.status == 401) {
                    Logout();
                }
            })
    }
    useEffect(() => {
        if (data) {
            GetMessage();
        }
        setMsgData({ ...msgData, project_id: data?.id, user_id: userDetails.id })
        // setMsg(data.messages)
    }, [data]);

    const FileUpload = (e) => {
        const file = e.target.files[0];
        let fileSize = file.size;
        setFileCount(e.target.files.length);
        if (Number(fileSize) >= 20 * 1024 * 1024) {
            WaringMessage("This image in getter than 20MB")
        } else {
            setMsgData({ ...msgData, file: e.target.files[0] });
        }
    }
    const scrollViewRef = useRef();
    const SubmitMsg = (e) => {
        e.preventDefault();
        console.log(msgData);

        if (msgData.message || msgData.file) {
            const formData = new FormData();
            formData.append("project_id", msgData.project_id)
            formData.append("user_id", msgData.user_id)
            formData.append("message", msgData.message)
            formData.append("file", msgData.file)
            PrivateAxiosFile.post("project/project-message-post", formData)
                .then((res) => {
                    console.log(res.data.data);

                    setMsg(res.data.data);
                    setMsgData({ ...msgData, message: "", file: "" })
                    // if (Tab == "inprogress") {
                    //     GetinprogressByTask()
                    // }
                    // if (Tab == "complete") {
                    //     GetcompleteByTask()
                    // }
                    // if (Tab == "todo") {
                    //     GetTodoByTask()
                    // }
                    // if (Tab == "close") {
                    //     GetcloseByTask();
                    // }
                    setFileCount(0)
                    // setTimeout(() => {
                    //     scrollViewRef.current?.scrollToEnd({ animated: true });
                    // }, 100);
                }).catch((err) => {
                    console.log(err);

                    if (err.response.status == 401) {
                        Logout();
                    }
                })
        } else {
            WaringMessage("Please give some message")
        }
    }

    return (
        <Offcanvas id="TTChat" className="chat-canvas" show={show} onHide={handleClose} placement="end" backdrop="static" >
            <Offcanvas.Header closeButton className="d-block gth-blue-light-bg">
                <Offcanvas.Title className="gth-modal-title">{data?.name && splitText(data.name, 30)}</Offcanvas.Title>
                <div className="short-details-wrap mt-2">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-2">
                                <label className="form-label">Project Name</label>
                                <p className="mb-0 f-s-14">{data?.project_name}</p>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2">
                                <label className="form-label d-flex">Project Head</label>
                                <div className='d-flex align-items-center flex-wrap multi-profile'>
                                    {data &&
                                        data.project_head_ids && JSON.parse(data.project_head_ids).map((id) => (

                                            User && User.map((item) => (
                                                item.id == id ?
                                                <Tooltip key={item.id} title={item.name} placement="top">
                                                    <div className="profile-wrap" key={item.id}>
                                                        <div className="exp-avtar bg-exp-green">
                                                            {item.user_photo != null ?
                                                                < img className="prof-img" src={item.user_photo && isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" /> :
                                                                <span>{item.name != '' ? item.name.split(' ').length > 1 ? item.name.split(' ')[0].split('')[0] + item.name.split(' ')[1].split('')[0] : item.name.split('')[0] + item.name.split('')[1] : ""}</span>
                                                            }
                                                        </div>
                                                        {/* <div className="ps-2 profile-name-wrap text-truncate">
                                                            <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
                                                        </div> */}
                                                    </div>
                                                    </Tooltip> : ""
                                            ))
                                        ))
                                    }
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2">
                                <label className="form-label">Status</label>
                                <p className="mb-0 f-s-14">{data?.status}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Header>
            {/* userDetails */}
            <Offcanvas.Body>
                <div className="chat-wrapper">
                    <div className="chat-conversation-wrap" ref={scrollViewRef}>
                        {msg.length > 0 && msg.map((item) => (
                            item.user_id == userDetails.id ?
                                <div className="chat-msg">
                                    <div className="chat-msg-profile-image">
                                        {data && User && User.map((UserItem) => (
                                            UserItem.id == userDetails.id ?
                                                < div className="profile-wrap" key={UserItem.id}>
                                                    <div className="exp-avtar bg-exp-green">
                                                        {UserItem.user_photo != null ?
                                                            < img className="prof-img" src={isURL(UserItem.user_photo) ? UserItem.user_photo : url + UserItem.user_photo} alt="user" /> :
                                                            <span>{UserItem.name != '' ? UserItem.name.split(' ').length > 1 ? UserItem.name.split(' ')[0].split('')[0] + UserItem.name.split(' ')[1].split('')[0] : UserItem.name.split('')[0] + UserItem.name.split('')[1] : ""}</span>
                                                        }
                                                    </div>
                                                    {/* <div className="ps-2 profile-name-wrap text-truncate">
                                                         <h5 className="profile-name text-nowrap text-truncate">{UserItem.name}</h5>
                                                     </div> */}
                                                </div> : ""
                                        ))
                                        }
                                    </div>
                                    <div className="chat-msg-content">
                                        <div className="chat-profile-name text-truncate">
                                            {User.find(data => data.id == userDetails.id).name} {item.audit_msg == 1 ? "(Audit Message)" : item.audit_msg == 2 ? "(Switch Doer Remark)" : ""}
                                        </div>
                                        <div className="chat-msg-text">
                                            {item.message && item.message != null ?
                                                item.message && item.message : ""
                                            }
                                            {
                                                item.file && item.file != null ?
                                                    <div className="chat-attachment-item">
                                                        {item.file && item.file.split('.').pop() == "png" || item.file.split('.').pop() == "jpg" || item.file.split('.').pop() == "jpeg" ?
                                                            <div className="icon">
                                                                <i className="fas fa-image"></i>
                                                            </div> : item.file.split('.').pop() == "pdf" ?
                                                                <div className="icon">
                                                                    <i className="fas fa-file-pdf"></i>
                                                                </div> : item.file.split('.').pop() == "doc" ?
                                                                    <div className="icon">
                                                                        <i className="fas fa-file-word"></i>
                                                                    </div> : item.file.split('.').pop() == "xls" || item.file.split('.').pop() == "xlsx" ?
                                                                        <div className="icon">
                                                                            <i className="fas fa-file-excel"></i>
                                                                        </div> : ""
                                                        }
                                                        <p className="text-truncate filename">{item.file && item.file}</p>
                                                        <button className="attachment-download action-btn" onClick={() => {
                                                            const link = document.createElement('a');
                                                            const UrlOrNot = isURL(item.file);
                                                            link.href = UrlOrNot ? item.file : url + item.file;
                                                            link.download = 'file.pdf';
                                                            link.target = "_blank";
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        }}>
                                                            <i className="fas fa-download"></i>
                                                        </button>
                                                    </div> : ""
                                            }
                                        </div>
                                        <div className="chat-msg-date">
                                            {item.created_at && moment(item.created_at).format('DD-MM-YYYY  | hh:mm A')}
                                        </div>
                                    </div>
                                </div> :
                                <div className="chat-msg owner">
                                    <div className="chat-msg-profile-image">
                                        {data && User && User.map((userItem) => (
                                            userItem.id == item.user_id ?
                                                < div className="profile-wrap" key={userItem.id}>
                                                    <div className="exp-avtar bg-exp-green">
                                                        {userItem.user_photo != null ?
                                                            < img className="prof-img" src={isURL(userItem.user_photo) ? userItem.user_photo : url + userItem.user_photo} alt="user" /> :
                                                            <span>{userItem.name != '' ? userItem.name.split(' ').length > 1 ? userItem.name.split(' ')[0].split('')[0] + userItem.name.split(' ')[1].split('')[0] : userItem.name.split('')[0] + userItem.name.split('')[1] : ""}</span>
                                                        }
                                                    </div>
                                                    {/* <div className="ps-2 profile-name-wrap text-truncate">
                                                         <h5 className="profile-name text-nowrap text-truncate">{userItem.name}</h5>
                                                     </div> */}
                                                </div> : ""
                                        ))
                                        }
                                    </div>
                                    <div className="chat-msg-content">
                                        <div className="chat-profile-name text-truncate">
                                            {User.find(data => data.id == item.user_id).name}{item.audit_msg == 1 ? "(Audit Message)" : item.audit_msg == 2 ? "(Switch Doer Remark)" : ""}
                                        </div>
                                        <div className="chat-msg-text">
                                            {item.message && item.message != null ?
                                                item.message && item.message : ""
                                            }
                                            {
                                                item.file && item.file != null ?
                                                    <div className="chat-attachment-item">
                                                        {item.file && item.file.split('.').pop() == "png" || item.file.split('.').pop() == "jpg" || item.file.split('.').pop() == "jpeg" ?
                                                            <div className="icon">
                                                                <i className="fas fa-image"></i>
                                                            </div> : item.file.split('.').pop() == "pdf" ?
                                                                <div className="icon">
                                                                    <i className="fas fa-file-pdf"></i>
                                                                </div> : item.file.split('.').pop() == "doc" ?
                                                                    <div className="icon">
                                                                        <i className="fas fa-file-word"></i>
                                                                    </div> : item.file.split('.').pop() == "xls" || item.file.split('.').pop() == "xlsx" ?
                                                                        <div className="icon">
                                                                            <i className="fas fa-file-excel"></i>
                                                                        </div> : ""
                                                        }
                                                        <p className="text-truncate filename">{item.file && item.file}</p>
                                                        <button className="attachment-download action-btn" onClick={() => {
                                                            const link = document.createElement('a');
                                                            const UrlOrNot = isURL(item.file);
                                                            link.href = UrlOrNot ? item.file : url + item.file;
                                                            link.download = 'file.pdf';
                                                            link.target = "_blank";
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        }}>
                                                            <i className="fas fa-download"></i>
                                                        </button>
                                                    </div> : ""
                                            }
                                        </div>
                                        <div className="chat-msg-date">
                                            {item.created_at && moment(item.created_at).format('DD-MM-YYYY  | hh:mm A')}
                                        </div>
                                    </div>
                                </div>
                        ))
                        }
                    </div>
                    <form onSubmit={SubmitMsg} className="chat-area-footer">
                        <div className="chat-file-upload custom-file-upload">
                            <i className="fas fa-paperclip"></i>
                            <input
                                type="file"
                                accept=".png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc"
                                name="myfile"
                                className="input-upload"
                                onChange={FileUpload}
                            // multiple  // Allow multiple files if needed
                            />
                            {fileCount > 0 && (
                                <span className="file-badge">
                                    {fileCount}
                                </span>
                            )}
                        </div>
                        <input
                            type="text"
                            placeholder="Type something here..."
                            value={msgData.message}
                            className="chat-input"
                            onChange={(e) => setMsgData({ ...msgData, message: e.target.value })}
                        />
                        <button type="submit" className="send-btn">
                            <i className="fas fa-paper-plane"></i>
                        </button>
                    </form>
                </div>

            </Offcanvas.Body>
        </Offcanvas >
    )
}
export default memo(ProjectMessage)
